module.exports = __webpack_public_path__ + "img/Pattern-02.5f77e35b.jpg";